(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["geenis-watch-listen"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-vslider]').forEach(function (slider) {
      var vids = slider.querySelectorAll('[data-vvid]');
      if (!vids.length || !('IntersectionObserver' in window)) return;

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting && e.intersectionRatio > 0.6) {
            v.play().catch(function () { /* autoplay blocked */ });
          } else {
            v.pause();
          }
        });
      }, { threshold: [0, 0.6, 1] });

      vids.forEach(function (v) { io.observe(v); });

      slider.querySelectorAll('[data-vsound]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var slide = btn.closest('.geenis-vslide');
          var v = slide && slide.querySelector('[data-vvid]');
          if (!v) return;
          if (v.muted) {
            // Mute every other video first
            document.querySelectorAll('[data-vvid]').forEach(function (o) { o.muted = true; });
            document.querySelectorAll('[data-vsound]').forEach(function (b) { b.textContent = '🔇'; });
            v.muted = false;
            v.play().catch(function () {});
            btn.textContent = '🔊';
          } else {
            v.muted = true;
            btn.textContent = '🔇';
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function () {
    var section = document.querySelector('.geenis-pdp');
    if (!section) return;
    var main = section.querySelector('[data-gallery-main]');
    var thumbs = Array.prototype.slice.call(section.querySelectorAll('[data-gallery-thumb]'));
    var counter = section.querySelector('[data-gallery-counter]');
    var galleryWrap = section.querySelector('[data-gallery-main-wrap]');
    var currentIndex = 0;

    function showIndex(i) {
      if (!thumbs.length || !main) return;
      currentIndex = ((i % thumbs.length) + thumbs.length) % thumbs.length;
      var btn = thumbs[currentIndex];
      main.src = btn.dataset.thumbSrc;
      if (btn.dataset.thumbSrcset) main.srcset = btn.dataset.thumbSrcset;
      main.alt = btn.dataset.thumbAlt || main.alt;
      thumbs.forEach(function (t, idx) {
        t.classList.toggle('is-active', idx === currentIndex);
        t.setAttribute('aria-pressed', idx === currentIndex ? 'true' : 'false');
      });
      if (counter) counter.textContent = (currentIndex + 1) + ' / ' + thumbs.length;
      // Scroll active thumb into view in the thumbs strip
      if (btn.scrollIntoView) btn.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    }

    thumbs.forEach(function (btn, idx) {
      btn.addEventListener('click', function () { showIndex(idx); });
    });
    var prevBtn = section.querySelector('[data-gallery-prev]');
    var nextBtn = section.querySelector('[data-gallery-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { showIndex(currentIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { showIndex(currentIndex + 1); });

    /* Touch swipe — horizontal threshold 40px, ignore vertical swipes */
    if (galleryWrap && thumbs.length > 1) {
      var touchStartX = 0, touchStartY = 0, touchMoved = false;
      galleryWrap.addEventListener('touchstart', function (e) {
        var t = e.touches[0];
        touchStartX = t.clientX; touchStartY = t.clientY; touchMoved = false;
      }, { passive: true });
      galleryWrap.addEventListener('touchmove', function (e) {
        var t = e.touches[0];
        if (Math.abs(t.clientX - touchStartX) > 8) touchMoved = true;
      }, { passive: true });
      galleryWrap.addEventListener('touchend', function (e) {
        if (!touchMoved) return;
        var t = e.changedTouches[0];
        var dx = t.clientX - touchStartX;
        var dy = t.clientY - touchStartY;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          if (dx < 0) showIndex(currentIndex + 1);
          else showIndex(currentIndex - 1);
        }
      });
    }
    var variantInput = section.querySelector('[data-variant-id-input]');
    var priceNow = section.querySelector('[data-price-now]');
    var priceCompare = section.querySelector('[data-price-compare]');
    var priceSave = section.querySelector('[data-price-save]');
    var stickyPrice = section.querySelector('[data-sticky-price]');
    var addBtn = section.querySelector('[data-add-btn]');
    var addLabel = section.querySelector('[data-add-label]');
    var stickyAdd = section.querySelector('[data-sticky-add]');
    function pickVariant(btn) {
      if (!btn) return;
      var price = btn.dataset.variantPrice;
      var compare = btn.dataset.variantCompare;
      var available = btn.dataset.variantAvailable === 'true';
      if (variantInput) variantInput.value = btn.dataset.variantId;
      if (priceNow) priceNow.textContent = price;
      if (stickyPrice) stickyPrice.textContent = price;
      if (compare && compare !== '' && compare !== price) {
        if (priceCompare) { priceCompare.textContent = compare; priceCompare.removeAttribute('hidden'); }
        if (priceSave) {
          var num = function (s) { return Number(String(s).replace(/[^\d.]/g, '')) || 0; };
          var c = num(compare), p = num(price);
          var pct = c > 0 ? Math.round(((c - p) / c) * 100) : 0;
          priceSave.textContent = 'Save ' + pct + '%';
          priceSave.removeAttribute('hidden');
        }
      } else {
        if (priceCompare) priceCompare.setAttribute('hidden', '');
        if (priceSave) priceSave.setAttribute('hidden', '');
      }
      section.querySelectorAll('[data-variant-pill]').forEach(function (p) {
        var isActive = p === btn;
        p.classList.toggle('is-active', isActive);
        p.setAttribute('aria-checked', isActive ? 'true' : 'false');
      });
      if (addBtn) {
        if (available) { addBtn.removeAttribute('disabled'); if (addLabel) addLabel.textContent = 'Add to cart'; }
        else { addBtn.setAttribute('disabled', ''); if (addLabel) addLabel.textContent = 'Sold out'; }
      }
      if (stickyAdd) {
        if (available) { stickyAdd.removeAttribute('disabled'); stickyAdd.textContent = 'Add to cart'; }
        else { stickyAdd.setAttribute('disabled', ''); stickyAdd.textContent = 'Sold out'; }
      }
    }
    section.querySelectorAll('[data-variant-pill]').forEach(function (btn) {
      btn.addEventListener('click', function () { pickVariant(btn); });
    });
    var qtyInput = section.querySelector('[data-qty-input]');
    var stickyDisplay = section.querySelector('[data-sticky-display]');
    function setQty(n) {
      var v = Math.max(1, parseInt(n, 10) || 1);
      if (qtyInput) qtyInput.value = v;
      if (stickyDisplay) stickyDisplay.textContent = v;
    }
    var qm = section.querySelector('[data-qty-minus]'); if (qm) qm.addEventListener('click', function () { setQty((parseInt(qtyInput && qtyInput.value, 10) || 1) - 1); });
    var qp = section.querySelector('[data-qty-plus]');  if (qp) qp.addEventListener('click', function () { setQty((parseInt(qtyInput && qtyInput.value, 10) || 1) + 1); });
    if (qtyInput) qtyInput.addEventListener('change', function () { setQty(qtyInput.value); });
    var sm = section.querySelector('[data-sticky-minus]'); if (sm) sm.addEventListener('click', function () { setQty((parseInt(qtyInput && qtyInput.value, 10) || 1) - 1); });
    var sp = section.querySelector('[data-sticky-plus]');  if (sp) sp.addEventListener('click', function () { setQty((parseInt(qtyInput && qtyInput.value, 10) || 1) + 1); });
    if (stickyAdd) stickyAdd.addEventListener('click', function () {
      var form = section.querySelector('form[data-type="add-to-cart-form"]');
      if (form) { if (form.requestSubmit) form.requestSubmit(); else form.submit(); }
    });
    section.querySelectorAll('[data-copy-code]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var code = btn.dataset.copyCode;
        try { navigator.clipboard.writeText(code); } catch (e) {}
        var orig = btn.textContent;
        btn.classList.add('is-copied'); btn.textContent = 'Copied!';
        setTimeout(function () { btn.classList.remove('is-copied'); btn.textContent = orig; }, 1800);
      });
    });
    document.body.classList.add('geenis-pdp-active');
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-mother"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('.geenis-mother');
    if (!section) return;

    var raw = section.parentElement.querySelector('[data-mother-batches]');
    if (!raw) raw = section.querySelector('[data-mother-batches]');
    var batches = [];
    try { batches = JSON.parse(raw.textContent); } catch (e) { batches = []; }
    if (!batches.length) return;

    var byDate = {};
    batches.forEach(function (b) { byDate[b.date] = b; });
    var latest = batches[0]; // server-sorted: newest first

    var form = section.querySelector('[data-mother-find]');
    var dateInput = section.querySelector('[data-mother-date]');
    var notice = section.querySelector('[data-mother-notice]');
    var result = section.querySelector('[data-mother-result]');
    var messageEl = section.querySelector('[data-mother-message-text]');

    function avatarSrc(photoUrl) {
      return photoUrl
        ? '<img src="' + photoUrl + '" alt="" width="138" height="138" loading="lazy">'
        : '<div class="geenis-mother__avatar-empty" aria-hidden="true"></div>';
    }

    function renderBatch(b) {
      var html = '';
      html += '<p class="geenis-mother__batch-tag">BATCH — ' + b.date_label + '</p>';
      html += '<h3 class="geenis-mother__batch-h">The hands that made yours</h3>';
      html += '<p class="geenis-mother__batch-sub">Every pack carries the names of the mothers who baked it. Here are yours.</p>';

      if (b.founder) {
        html += '<div class="geenis-mother__founder">';
        html += '<div class="geenis-mother__avatar geenis-mother__avatar--lg">' + avatarSrc(b.founder.photo) + '</div>';
        html += '<p class="geenis-mother__role">' + b.founder.role + '</p>';
        html += '<p class="geenis-mother__name">' + b.founder.name + '</p>';
        html += '</div>';
      }
      if (b.makers && b.makers.length) {
        html += '<div class="geenis-mother__cards">';
        b.makers.forEach(function (m) {
          html += '<div class="geenis-mother__card">';
          html += '<div class="geenis-mother__avatar">' + avatarSrc(m.photo) + '</div>';
          html += '<p class="geenis-mother__role">' + m.role + '</p>';
          html += '<p class="geenis-mother__name">' + m.name + '</p>';
          html += '</div>';
        });
        html += '</div>';
      }
      result.innerHTML = html;

      // Swap the top quote to this batch's message if it has one
      if (messageEl && b.message) messageEl.textContent = b.message;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var picked = dateInput.value;
      if (!picked) {
        notice.textContent = 'Pick a date first.';
        notice.removeAttribute('hidden');
        return;
      }
      if (byDate[picked]) {
        notice.setAttribute('hidden', '');
        notice.textContent = '';
        renderBatch(byDate[picked]);
      } else {
        notice.textContent = 'This date still needs to be updated — showing the latest available batch below.';
        notice.removeAttribute('hidden');
        dateInput.value = latest.date;
        renderBatch(latest);
      }
    });

    // Copy code button (CTA)
    section.querySelectorAll('[data-mother-copy]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-mother-copy');
        try { navigator.clipboard.writeText(code); } catch (e) {}
        var orig = btn.textContent;
        btn.classList.add('is-copied');
        btn.textContent = 'Copied!';
        setTimeout(function () { btn.classList.remove('is-copied'); btn.textContent = orig; }, 1800);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
